






























































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Pile} from '@/models';

import CrudPileFilter from '@/components/Crud/Pile/Filter.vue';
import CrudPileShowDialog from '@/components/Crud/Pile/ShowDialog.vue';
import CrudPileEditDialog from '@/components/Crud/Pile/EditDialog.vue';
import CrudPileList from '@/components/Crud/Pile/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storePile, {PileFilter} from '@/stores/modules/pile';

@Component({
	components: {
		CrudPileFilter,
		CrudPileShowDialog,
		CrudPileEditDialog,
		CrudPileList,
		CrudDeleteDialog,
	}
})
export default class PileView extends Vue {
	
	@Stored(() => storePile)
	private piles!: ResultType<Pile>;
	
	@Stored(() => storePile)
	private filters!: PileFilter;

	private showPile: Pile = null;
	private editPile: Pile = null;
	private deletedPile: Pile = null;
	private storePile = storePile;

	@Emit()
	private onCreate(): void {
		this.editPile = new Pile();
	}

	public mounted(): void {
		console.log("Mounted pile");
		this.filters.clear();
	}

	private refresh(): void {
		storePile.dispatch('getC', { filters: true });
	}
}
